import { render, staticRenderFns } from "./contractNoSurchargeFclDialog.vue?vue&type=template&id=b5a6dbca&"
import script from "./contractNoSurchargeFclDialog.vue?vue&type=script&lang=js&"
export * from "./contractNoSurchargeFclDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5a6dbca')) {
      api.createRecord('b5a6dbca', component.options)
    } else {
      api.reload('b5a6dbca', component.options)
    }
    module.hot.accept("./contractNoSurchargeFclDialog.vue?vue&type=template&id=b5a6dbca&", function () {
      api.rerender('b5a6dbca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/contractNoSurchargeFclDialog.vue"
export default component.exports